import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { calculate } from "@/lib/apolloCalc";
import { sendSimulationEmail } from "@/lib/formsubmit";
import { track } from "@/lib/track";

// Coordinate scritte dall'utente, es. "46.0031, 8.9503"
export const parseCoords = (text) => {
  const m = (text || "").trim().match(/^(-?\d{1,2}(?:\.\d+)?)\s*[,; ]\s*(-?\d{1,3}(?:\.\d+)?)$/);
  if (!m) return null;
  const lat = Number(m[1]);
  const lng = Number(m[2]);
  return Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat, lng } : null;
};

// Stato del calcolatore Apollo.AI: 1) dati 2) conferma stabile sulla mappa 3) risultato
export function useApolloCalculator() {
  const [form, setForm] = useState({ address: "", buildingType: "Villa Unifamiliare", consumption: "", coords: "" });
  const [step, setStep] = useState("form");
  const [pin, setPin] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [mailStatus, setMailStatus] = useState("idle");
  const [mailError, setMailError] = useState("");

  // Mostra il risultato e invia la simulazione via email (il pulsante WhatsApp resta sempre attivo)
  const finish = async (res) => {
    setResult(res);
    setStep("result");
    setMailStatus("sending");
    try {
      await sendSimulationEmail(res);
      setMailStatus("sent");
      track("generate_lead", { method: "simulazione" });
    } catch (err) {
      setMailError(err.message);
      setMailStatus("error");
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (form.address.trim().length < 3) return setError("Inserisci via e città.");
    if (form.coords.trim() && !parseCoords(form.coords)) return setError("Coordinate non valide. Formato: 46.0031, 8.9503");
    setError("");
    setResult(null);
    track("calcola_apollo_ai");
    const typed = parseCoords(form.coords);
    if (typed) {
      setPin(typed);
      return setStep("locate");
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/geocode`, { address: form.address });
      setPin({ lat: data.lat, lng: data.lng });
      setStep("locate");
    } catch (err) {
      // Mappa non disponibile: si calcola subito con la stima per zona
      console.info("Geocoding non disponibile:", err?.response?.status || err?.message);
      finish(calculate(form, null));
    }
    setLoading(false);
  };

  const confirm = async () => {
    setLoading(true);
    let geo = null;
    try {
      geo = (await axios.post(`${API}/solar`, { address: form.address, lat: pin.lat, lng: pin.lng })).data;
    } catch (err) {
      console.info("Analisi satellitare non disponibile, uso la stima per zona:", err?.response?.status || err?.message);
    }
    setLoading(false);
    finish(calculate(form, geo));
  };

  const back = () => setStep("form");

  return { form, setForm, step, pin, setPin, loading, result, error, submit, confirm, back, mailStatus, mailError };
}
